<template>
    <select-c v-model="currentPeriod" :label="label" :options="periods"></select-c>
</template>

<script setup>
import { ref, watch, inject } from 'vue';

const props = defineProps({
    periods: Array,
    label: String
});

const eventBus = inject('eventBus');

const currentPeriod = ref(null);

watch(currentPeriod, (newValue) => {
    eventBus.emit('periodChanged', newValue);
});
</script>
